import React from 'react';

import { useMessages } from '../i18n';
import { catalogUrl } from '../links';

// "Vidya AI" in the learner header's main menu (every learner-facing app).
const VidyaNavLink = () => {
  const t = useMessages();
  const active = window.location.pathname.startsWith('/vidya');
  return (
    <a className={`nav-link bm-nav-vidya${active ? ' active' : ''}`} href={catalogUrl('vidya')}>
      <span className="bm-nav-vidya__spark" aria-hidden="true">✦</span>{t.vdNav}
    </a>
  );
};

export default VidyaNavLink;
